export function openApp(appId, treeId) {
  return {
    type: 'OPEN_APP',
    appId,
    treeId
  };
}

export function openDatasheet(key, treeId) {
  return {
    type: 'OPEN_DATASHEET',
    key,
    treeId
  };
}

export function cyberCounterStart() {
  return {
    type: 'CYBER_COUNTER_START',
    meta: {
      sendServer: true,
    }
  };
}

export function pushCyberCounterStart(duration, sequence, userActions) {
  return {
    type: 'PUSH_CYBER_COUNTER_START',
    duration,
    sequence,
    userActions,
    meta: {
      sendClient: true,
    }
  };
}

export function pushCyberCounterStop() {
  return {
    type: 'PUSH_CYBER_COUNTER_STOP',
    meta: {
      sendClient: true,
    }
  };
}

export function cyberCounterSymbolClick(id) {
  return {
    type: 'CYBER_COUNTER_SYMBOL_CLICK',
    id,
    meta: {
      sendServer: true,
    }
  };
}

export function pushCyberCounterSequenceIndex(sequenceIndex) {
  return {
    type: 'PUSH_CYBER_COUNTER_SEQUENCE_INDEX',
    sequenceIndex,
    meta: {
      sendClient: true,
    }
  };
}

export function pushCyberCounterWrongSymbol(sequenceIndex) {
  return {
    type: 'PUSH_CYBER_COUNTER_WRONG_SYMBOL',
    sequenceIndex,
    meta: {
      sendClient: true,
    }
  };
}


export function pushCyberCounterSuccess() {
  return {
    type: 'PUSH_CYBER_COUNTER_SUCCESS',
    meta: {
      sendClient: true,
    }
  };
}

export function cyberCounterLeave() {
  return {
    type: 'CYBER_COUNTER_LEAVE',
  };
}

export function pushCyberCounterNeedMorePlayers() {
  return {
    type: 'PUSH_CYBER_COUNTER_NEED_MORE_PLAYERS',
  };
}

export function cltFileTreeLoadTree(id) {
  return {
    type: 'CLT_FILE_TREE_LOAD_TREE',
    id,
  }
}